export class ReportState {
    loading = false;
    record: any = {};
}
